import { bus } from "@/main";

/** Promise wrapper around the shared confirm modal: resolves true when the user confirms. */
export function confirmAsk(vm, text, title = 'اخطار', button = 'تایید') {
  return new Promise((resolve) => {
    const tag = 'confirm_' + Date.now() + '_' + Math.random().toString(36).slice(2)
    bus.$once(tag, (v) => resolve(v === 'true'))
    vm.$root.modal_component.show_confirm_modal(title, text, [button], tag)
  })
}

export function apiToast(vm, res) {
  try { vm.$root.modal_component.show_api_response_modals(res) } catch (e) { /* modal not mounted */ }
}
